import React from 'react';
import { makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import SearchFilters from 'src/components/AnageImoveis/SearchFilters';
import MainProperties from './MainProperties';
import Categories from './Categories';
import SecondaryBanner from './SecondaryBanner';
import AdInfo from './AdInfo';

const useStyles = makeStyles(() => ({
  root: {}
}));

function Home() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Anagê Imóveis"
    >
      <MainProperties />
      <SearchFilters />
      <Categories />
      <SecondaryBanner />
      <AdInfo />
    </Page>
  );
}

export default Home;
